import { Component } from '@angular/core';
import {CommonModule} from "@angular/common";
import {RouterModule} from "@angular/router";
import {MatButton} from "@angular/material/button";

@Component({
  selector: 'app-permission-denied',
  standalone: true,
  imports: [CommonModule, RouterModule, MatButton],
  templateUrl: './permission-denied.component.html',
  styleUrls: ['./permission-denied.component.css']
})
export class PermissionDeniedComponent {
  constructor() { }
}
